export default class Preloader {
  private mainCont: HTMLElement | null;
  private preloaderBar: HTMLElement | null = null;

  constructor() {
    this.mainCont = document.querySelector('.preloader');
    this.preloaderBar = document.querySelector('.preloader-bar');
    if (this.preloaderBar) {
      this.preloaderBar.style.width = '0';
    }
  }

  updateLoader(progress: number) {
    if (this.preloaderBar) {
      this.preloaderBar.style.width = progress + '%';
    }
  }

  hide() {
    if (this.mainCont) {
      this.mainCont.style.display = 'none';
    }
  }
}
